/* eslint-disable max-len */
/* eslint-disable fp/no-mutating-methods */
import { Swiper, SwiperSlide } from 'swiper/react'
import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper'

import { splitEvery } from 'ramda'
import { useAppSelector } from 'src/store/hooks'
import {
  selectSectionById,
  selectCoursesBySection,
  selectCompletedCourses,
  selectIncompleteAssignmentCourses,
} from 'src/v3/self-paced/self-paced.slice'
import { useNavigate, useParams } from 'react-router-dom'
import { ReactElement } from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { assignedMarker, completeMarker } from 'src/v3/self-paced'
import { Course } from '../core/types'

export default (): ReactElement => {
  let { sectionId } = useParams()
  let navigate = useNavigate()

  let section = useAppSelector(selectSectionById(sectionId ?? ''))
  let courses = useAppSelector(selectCoursesBySection(sectionId ?? ''))
  let completedCourses = useAppSelector(selectCompletedCourses)
  let incompleteAssignmentCourses = useAppSelector(selectIncompleteAssignmentCourses)

  let largeScreen = useMediaQuery('(min-width:1000px)')

  let imageUrl: Record<string, string> = {
    '71c5d72b-3d17-438d-a692-649779e3b020': `${import.meta.env.VITE_CLOUDFRONT_URL}/public/ARV.png`,
    'e1a3c7bb-11ff-4af5-821f-8efbaae3b3d4': `${import.meta.env.VITE_CLOUDFRONT_URL}/public/Cardiovascular.png`,
    '1acfde29-b316-4ec7-8500-865f6251303c': `${import.meta.env.VITE_CLOUDFRONT_URL}/public/Trauma.png`,
    'a7ce1591-f5cc-445d-90a2-2a61de56a467': `${import.meta.env.VITE_CLOUDFRONT_URL}/public/Medical.png`,
    'de34454e-471e-4d25-9c1d-1cf0dfb60875': `${import.meta.env.VITE_CLOUDFRONT_URL}/public/Pediatric.png`,
    '73e8b4ee-a1d3-4b77-95cc-5e263b2fc717': `${import.meta.env.VITE_CLOUDFRONT_URL}/public/Operations.png`,
    'ca3d02f1-ad3f-4aa2-9e6d-6c4dc3d965f7': `${import.meta.env.VITE_CLOUDFRONT_URL}/public/CriticalCare.png`,
  }

  return (
    <>
      {imageUrl[sectionId ?? ''] ? (
        <img src={imageUrl[sectionId ?? '']} style={{ width: '100%' }} />
      ) : (
        <div
          style={{
            minWidth: '100%',
            background: 'url(/banner.png)',
            minHeight: '200px',
            backgroundPosition: '0px 48%',
            backgroundSize: 'cover',
          }}
          className="flex flex-wrap justify-center align-content-center"
        >
          <Typography
            variant="h4"
            style={{ color: 'white', fontFamily: 'smileAndWave' }}
          >
            {section?.name}
          </Typography>
        </div>
      )}
      <div className="mt-4">
        {splitEvery(largeScreen ? 5 : 3, courses).map((items: Course[]) => (
          <Swiper
            cssMode={true}
            slidesPerView={largeScreen ? 5 : 3}
            spaceBetween={10}
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            className="netflix-slider"
          >
            {items.map((item: Course) => {
              let isCompleted = completedCourses.some(cc => cc === item.id)
              let isAssigned = incompleteAssignmentCourses.includes(item.id)

              return (
                <SwiperSlide key={item.id} style={{ position: 'relative' }}>
                  {(isCompleted && !isAssigned) && completeMarker}
                  {isAssigned && assignedMarker}
                  <Box sx={{ bgcolor: 'background.default' }}>
                    <img
                      style={{
                        cursor: 'pointer',
                        opacity: (isCompleted && !isAssigned) ? 0.4 : 1,
                      }}
                      onClick={() => navigate(`/self-paced/course/${item.id}`)}
                      src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${item.imageName}`}
                      alt={item.displayName}
                    />
                  </Box>
                </SwiperSlide>
              )
            })}
          </Swiper>
        ))}
      </div>
    </>
  )
}
